import React, { useState } from "react";

const DownloadButton = ({ onClick, isImage = false, file, children }) => {
  const [downloading, setDownloading] = useState(false);

  const downloadClick = async () => {
    setDownloading(true);
    await onClick(file);
    setDownloading(false);
  };

  return (
    <>
      <button onClick={downloadClick} className="text-proof-blue flex items-center gap-2 font-medium hover:underline">
        {downloading && !isImage && (
          <span className="relative flex h-3 w-3">
            <span className="bg-proof-blue absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"></span>
            <span className="bg-proof-blue relative inline-flex h-3 w-3 rounded-full"></span>
          </span>
        )}
        {children}
      </button>
    </>
  );
};
export default DownloadButton;
